export const FinanceStats = {
  // Aggregated finance stats
  GET_FINANCE_AGGREGATED_STATS: "GET_FINANCE_AGGREGATED_STATS",
  GET_FINANCE_AGGREGATED_STATS_SUCCESS: "GET_FINANCE_AGGREGATED_STATS_SUCCESS",
  
  // Wallets
  GET_WALLETS: "GET_WALLETS",
  GET_WALLETS_SUCCESS: "GET_WALLETS_SUCCESS",
  
  // Transactions
  GET_TRANSACTIONS: "GET_TRANSACTIONS",
  GET_TRANSACTIONS_SUCCESS: "GET_TRANSACTIONS_SUCCESS",
  
  // Shared wallets
  GET_SHARED_WALLETS: "GET_SHARED_WALLETS",
  GET_SHARED_WALLETS_SUCCESS: "GET_SHARED_WALLETS_SUCCESS",
  
  // Bank integrations
  GET_BANK_INTEGRATIONS: "GET_BANK_INTEGRATIONS",
  GET_BANK_INTEGRATIONS_SUCCESS: "GET_BANK_INTEGRATIONS_SUCCESS",
};

// Action creators
export const getFinanceAggregatedStats = (payload) => ({
  type: FinanceStats.GET_FINANCE_AGGREGATED_STATS,
  payload,
});

export const getWallets = (payload) => ({
  type: FinanceStats.GET_WALLETS,
  payload,
});

export const getTransactions = (payload) => ({
  type: FinanceStats.GET_TRANSACTIONS,
  payload,
});

export const getSharedWallets = (payload) => ({
  type: FinanceStats.GET_SHARED_WALLETS,
  payload,
});

export const getBankIntegrations = (payload) => ({
  type: FinanceStats.GET_BANK_INTEGRATIONS,
  payload,
});